import { PackageTypeEnum, WorkshopSystemEnum } from "src/domain/client";
import { SelectedPackages } from "./booking.modals";

export const systemToFormNameMap: {
  [key in WorkshopSystemEnum]?: keyof SelectedPackages;
} = {
  [WorkshopSystemEnum.Service]: "serviceForm",
  [WorkshopSystemEnum.Troubleshooting]: "troubleshootingForm",
  [WorkshopSystemEnum.Wheel]: "wheelForm",
  [WorkshopSystemEnum.Windscreen]: "windscreenForm",
  [WorkshopSystemEnum.TechUpdate]: "techUpdateForm",
  [WorkshopSystemEnum.Other]: "other"
};

export const systemToPackageTypeMap: {
  [key in WorkshopSystemEnum]?: PackageTypeEnum;
} = {
  [WorkshopSystemEnum.Troubleshooting]: PackageTypeEnum.Troubleshooting,
  [WorkshopSystemEnum.Wheel]: PackageTypeEnum.Wheel,
  [WorkshopSystemEnum.Windscreen]: PackageTypeEnum.Windshield,
  [WorkshopSystemEnum.TechUpdate]: PackageTypeEnum.TechUpdate
};

export const packageTypeToSystemMap: {
  [key in PackageTypeEnum]?: WorkshopSystemEnum;
} = {
  [PackageTypeEnum.OriginalService]: WorkshopSystemEnum.Service,
  [PackageTypeEnum.BaseService]: WorkshopSystemEnum.Service,
  [PackageTypeEnum.Troubleshooting]: WorkshopSystemEnum.Troubleshooting,
  [PackageTypeEnum.Wheel]: WorkshopSystemEnum.Wheel,
  [PackageTypeEnum.Windshield]: WorkshopSystemEnum.Windscreen,
  [PackageTypeEnum.TechUpdate]: WorkshopSystemEnum.TechUpdate
};
